module.exports = __webpack_public_path__ + "2e3033b0855df7e658154881e9658f91.woff";


//////////////////
// WEBPACK FOOTER
// ./src/lib/icon/iconfont.woff?t=1552554261471
// module id = 13
// module chunks = 0